import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class NavigationTabsModuleLiveBadgeRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + `/Live_icon`
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}